import { useContext } from 'react';

import { context } from '../components/PlansProvider';

export const usePlans = (): Plan[] => useContext(context).plans;
